import {
  type HistoryOptions,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

export function useBankTransferDetailDrawer() {
  const [opts, set] = useQueryStates({
    transfer: parseAsString,
  });

  return {
    opened: !!opts.transfer,
    open: (id: string, type?: HistoryOptions) => {
      removeDrawerStateFromUrl();
      set(
        { transfer: id },
        {
          history: type || 'push',
        }
      );
    },
    close: () => set(null),
    bankTransferId: opts.transfer,
  };
}
